import { AppException } from './exception.error';

export class ForbiddenException extends AppException {

    constructor(clazz: string, message?: string, error?: Error) {
        super(clazz, message, error);
        this.stack = error?.stack;
    }
}